import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-page-utility-controls",
    templateUrl: "./edit-page-utility-controls.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPageUtilityControlsComponent {

}
